import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';
import { ForumThreadShape } from 'entities';
import Link from 'components/Link';

const ForumThread = props => {

  const { forumThread = {author: {}} } = props;
  const className = classnames('ForumThread', {
    'is-empty': props.isEmpty,
    'is-live': props.isLive,
    'is-inline': props.isInline
  });

  return (
    <div className={className}>
      <div className="discussion-inner">
        <div className="title-wrapper">
          <h4>
            <span>{forumThread.title}</span>
            {props.isLive && <span className="live-label">{__('members.forum.titles.live')}</span>}
          </h4>
        </div>

        <div className="author">{forumThread.author.userName}</div>
        <div className="time">{props.timeInfo}</div>
        <div className="replies"><strong>{forumThread.commentCount}</strong> {__('entities.replies.plural')}</div>

        <div className="discussion-link">
          <Link to={`/forum/threads/${forumThread.id}`} />
        </div>
      </div>
    </div>
  );
};

ForumThread.propTypes = {
  forumThread: ForumThreadShape,
  timeInfo: PropTypes.string,
  isEmpty: PropTypes.bool,
  isLive: PropTypes.bool,
  isInline: PropTypes.bool
};


export default ForumThread;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ForumThreadsList/ForumThread/index.js
 **/